import styled from "styled-components";

export const McqSectionContainer = styled.div`
  padding: 14px;
  width: 100%;
  background-color: #fafafa;
  border-radius: 10px;
  margin: 14px 0px;
`;
